import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import DisplayFieldBadge from '../display-field-badge/display-field-badge';
import DisplayFieldLink from '../display-field-link/display-field-link';
import DisplayContactLink from '../display-contact-link/display-contact-link';

@Component({
  name: 'bpc-display-field-badge-link',
  components: {},
})
export default class DisplayFieldBadgeLink extends mixins(
  AbstractDisplayField,
  DisplayFieldLink,
  DisplayFieldBadge,
  DisplayContactLink,
) {}
